export const VARIANTS = {
  primary: 'contained',
  secondary: 'outlined',
  tertiary: 'text',
  tertiarySpecial: 'text',
};
